import React, { useContext } from "react";
import { LumpSection } from "../context/LumpContext";
import { useTranslation } from "react-i18next";
const KeyLamp = () => {
  const { t } = useTranslation();
  const { ShowHideLumpFunction } = useContext(LumpSection);

  return (
    <div className="mb-4">
      <div className="d-flex align-items-center weatherStatus">
        <i className="circleTop icon-lump text-center"></i>
        <div className="text-center mr-4">
          <p className="m-0">{t("لامپ")}</p>
          <small className="text-muted-left">{t("روشن")}</small>
        </div>
      </div>
      <div style={{ maxHeight: "70vh" }}>
        <div
          className="d-flex mb-4 justify-content-center align-items-center"
          style={{ height: "35vh" }}
        >
          <div className="rotate position-absolute">
            <input type="checkbox" id="key-lamp-switch" />
            <label className="keyLampSwitch" for="key-lamp-switch"></label>
          </div>
          <div className="rotate">
            <input type="checkbox" id="key-lamp-switch2" />
            <label className="keyLampSwitch" for="key-lamp-switch2"></label>
          </div>
          <div className="rotate">
            <input type="checkbox" id="key-lamp-switch3" />
            <label className="keyLampSwitch" for="key-lamp-switch3"></label>
          </div>
        </div>
        <div className="d-flex justify-content-center mb-4">
          <div className="lightStatus fn10 py-1 px-3">
            {t("روشنایی اتوماتیک")}
          </div>
        </div>
        <div
          className="d-flex flex-wrap justify-content-center"
          style={{ height: "15vh" }}
        >
          <div className="mx-3 mb-2 d-flex justify-content-center align-items-center flex-column text-center">
            <span className="profileAddUser bg-white d-block cursor icon-tvv text-dark"></span>
            <small className="fn10 mt-1">{t("صحنه")}</small>
          </div>
          <div className="mx-3 mb-2 d-flex justify-content-center align-items-center flex-column text-center">
            <span
              onClick={() => ShowHideLumpFunction("lumpTime")}
              className="profileAddUser bg-white d-block cursor icon-slepp text-dark"
            ></span>
            <small className="fn10 mt-1">{t("زمان")}</small>
            <small className="fn8">{t("8صبح،6شب")}</small>
          </div>
        </div>

        <div
          className="d-flex flex-wrap justify-content-center"
          style={{ height: "15vh" }}
        >
          <div className="mx-3 mb-2 d-flex justify-content-center align-items-center flex-column text-center">
            <span className="profileAddUser bg-white d-block cursor icon-seti"></span>
            <small className="fn10 mt-1">{t("تنظیمات")}</small>
          </div>
          <div className="mx-3 mb-2 d-flex justify-content-center align-items-center flex-column text-center">
            <span className="profileAddUser bg-white d-block cursor icon-off"></span>
            <small className="fn10 mt-1">{t("خاموش")}</small>
          </div>
          <div className="mx-3 mb-2 d-flex justify-content-center align-items-center flex-column text-center">
            <span className="profileAddUser bg-white d-block cursor icon-left-1"></span>
            <small className="fn10 mt-1">{t("بازگشت")}</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export { KeyLamp };
